/**
 * Quote Negotiation Service - Handles quote negotiation workflows
 */

import api from "../../../shared/api.jsx";
import { logError } from "../../../shared/utils/logger.js";

/**
 * Start negotiation for a quote
 * @param {Object} negotiationData - Negotiation data including quoteId, initiatedBy, and reason
 * @returns {Promise<Object>} Negotiation result
 */
export const startNegotiation = async (negotiationData) => {
  try {
    const response = await api.post(
      "/quotes/negotiation/start",
      negotiationData
    );
    return response;
  } catch (error) {
    logError("Error starting negotiation", {
      negotiationData,
      error: error.message,
      status: error.response?.status,
    });
    return {
      success: false,
      error: error.message || "Failed to start negotiation",
    };
  }
};

/**
 * Request amount change for a quote
 * @param {Object} amountChangeData - Amount change data including quoteId, newAmount, requestedBy, and reason
 * @returns {Promise<Object>} Amount change result
 */
export const requestAmountChange = async (amountChangeData) => {
  try {
    const response = await api.post(
      "/quotes/negotiation/amount-change",
      amountChangeData
    );
    return response;
  } catch (error) {
    logError("Error requesting amount change", {
      amountChangeData,
      error: error.message,
      status: error.response?.status,
    });
    return {
      success: false,
      error: error.message || "Failed to request amount change",
    };
  }
};
